import React from 'react'

const SingleEvent = ({currentEvent:{titre,date,bio,cover,galery}}) => {
  
  return (
    
        <div className='w-full grid gap-4'>
          <div className='grid grid-cols-2 w-full p-8 justify-items-center'>
            <div className='p-4 grid gap-8'>
                <div className=''>
                <h1 className='text-4xl text-[#006DC4]'>{titre}</h1>
                {date && <h2 className='text-xl text-[#54B3FF]'>{date.slice(0, 10)}</h2>}
                </div>
                <p className='text-[#5A5A5A] text-lg'>{bio}</p>
            </div>
            <img className='max-h-[500px] w-auto'  src={`https://cdn.sanity.io/images/xazjl9sh/production/${cover.slice(6, -4) + '.' + cover.slice(-3)}`} alt="someImg" />

        </div>
        <div className='w-full p-4 grid grid-cols-3 justify-items-center justify-evenly'>
          {galery.length > 0 && galery.map((e,i)=>{
            return <img alt="someimg" className='h-72 w-auto' src={`https://cdn.sanity.io/images/xazjl9sh/production/${e.asset._ref.slice(6, -4) + '.' + e.asset._ref.slice(-3)}`} />
          })}

        </div>
        </div>
  )
}

export default SingleEvent
